import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f64c41bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, "StarTimes ON H5 Cashier");
}